<template>
  <div class="loginBody">
    <login-nav></login-nav>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
	  <el-form-item label="姓名" required>
	    <el-input v-model="formInline.user" placeholder="姓名"></el-input>
	  </el-form-item>
	  <el-form-item label="会员编号" required>
	    <el-input v-model="formInline.user" placeholder="会员编号"></el-input>
	  </el-form-item>
	  <el-form-item label="年份列表" required>
	    <el-select v-model="formInline.region" placeholder="年份列表">
	      <el-option label="区域一" value="shanghai"></el-option>
	      <el-option label="区域二" value="beijing"></el-option>
	    </el-select>
	  </el-form-item>
	  <el-form-item>
	    <el-button type="primary">查询</el-button>
	  </el-form-item>
	</el-form>
  </div>
</template>

<script>
	import LoginNav from '../../components/loginNav.vue';
	export default {
		components:{LoginNav},
		name: 'search',
		data () {
		    return {
		      formInline:{
		      	user:'',
		      	region:'',
		      },
		    }
		}
	}
</script>

<style scoped>
.loginBody{
  min-width:300px;
  max-width:1200px;
  width:90%;
  background:#fff;
  border-radius:5px;
  padding:0 0 60px 0;
  margin:25px auto 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/celebrities/search.vue